import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TooltipWrapper from 'shared/components/TooltipWrapper';

export default class EllipsisTooltipText extends Component {

  componentWillMount() {
    this.showTooltip = false;
  }

  render() {
    const {text, tooltipStyle, anchorOrigin, targetOrigin, popoverType} = this.props;
    return (
      <TooltipWrapper
        tooltip={this.showTooltip && text}
        popoverType={popoverType}
        anchorOrigin={anchorOrigin}
        targetOrigin={targetOrigin}
        tooltipStyle={{maxWidth: 'auto', padding: '0 8px', fontSize: '10px', lineHeight: '22px', ...tooltipStyle}}
      >
        <div
          ref={(ref) => ref && ref.offsetWidth < ref.scrollWidth ? this.showTooltip = true : null}
          style={{textOverflow: 'ellipsis', overflow: 'hidden'}}
        >
          {text}
        </div>
      </TooltipWrapper>
    );
  }
}

EllipsisTooltipText.propTypes = {
  text: PropTypes.string.isRequired,
  tooltipStyle: PropTypes.object,
  anchorOrigin: PropTypes.object,
  targetOrigin: PropTypes.object,
  popoverType: PropTypes.oneOf(['grey', 'withArrow']),
};

EllipsisTooltipText.defaultProps = {
  popoverType: 'grey',
  anchorOrigin: {horizontal: 'right', vertical: 'center'},
  targetOrigin: {horizontal: 'left', vertical: 'center'},
};